import axios from 'axios';


// You can set REACT_APP_API_URL in .env file
const API_URL = process.env.REACT_APP_API_URL || 'https://taskflowapi.webseller.in/api';

// Configure axios with auth token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Get all clients
export const getClients = async () => {
  try {
    const response = await axios.get(`${API_URL}/clients`);
    return response.data;
  } catch (error) {
    console.error('Error fetching clients:', error);
    throw error;
  }
};

// Get client by ID
export const getClientById = async (clientId) => {
  try {
    const response = await axios.get(`${API_URL}/clients/${clientId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching client ${clientId}:`, error);
    throw error;
  }
};

// Create new client
export const createClient = async (clientData) => {
  try {
    const response = await axios.post(`${API_URL}/clients`, clientData);
    return response.data;
  } catch (error) {
    console.error('Error creating client:', error);
    throw error;
  }
};

// Update client
export const updateClient = async (clientId, updateData) => {
  try {
    const response = await axios.put(`${API_URL}/clients/${clientId}`, updateData);
    return response.data;
  } catch (error) {
    console.error(`Error updating client ${clientId}:`, error);
    throw error;
  }
};

// Delete client
export const deleteClient = async (clientId) => {
  try {
    const response = await axios.delete(`${API_URL}/clients/${clientId}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting client ${clientId}:`, error);
    throw error;
  }
};